import {
  SET_CONTENT
} from './types';

export default {
  [SET_CONTENT](state, payload) {
    state.content = payload;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/bundles/mutations.js